import { render, staticRenderFns } from "./MamLeaderBoard.vue?vue&type=template&id=2e75b66d&scoped=true"
import script from "./MamLeaderBoard.vue?vue&type=script&lang=js"
export * from "./MamLeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./MamLeaderBoard.vue?vue&type=style&index=0&id=2e75b66d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e75b66d",
  null
  
)

export default component.exports